<body>
  <app-nav-menu></app-nav-menu>
  <router-outlet></router-outlet>

  <!--<app-footer></app-footer>-->

</body>
